import { useEffect } from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router";
import { AppShell } from "./components/AppShell";
import { NotFound, Splash, StartError } from "./components/StatusScreens";
import { DEV_TAB_PATHS, devTab, takeOnce } from "./core/devhooks";
import { useSession } from "./core/session";
import { AchievePage } from "./pages/achieve";
import { AssistantPage, AssistantSettingsPage } from "./pages/assistant";
import { HomePage } from "./pages/home";
import { LearnPage } from "./pages/learn";
import { LoginPage } from "./pages/login";
import { McpPage, MePage } from "./pages/me";
import { SchedulePage } from "./pages/schedule";
import { ConfirmDialog, ToastHost } from "./ui";

export function App() {
  const phase = useSession((s) => s.phase);
  return (
    <>
      {phase === "loading" && <Splash />}
      {phase === "error" && <StartError />}
      {phase === "login" && <LoginPage />}
      {phase === "ready" && <ReadyApp />}
      <ToastHost />
      <ConfirmDialog />
    </>
  );
}

/** 登录后的路由。新增页面：在 src/pages/<名称>/index.tsx 导出组件，再在这里加一条 Route（见 docs/网页版.md） */
function ReadyApp() {
  const navigate = useNavigate();
  useEffect(() => {
    const tab = devTab();
    if (tab && DEV_TAB_PATHS[tab] && takeOnce("dev_tab")) navigate(DEV_TAB_PATHS[tab]!, { replace: true });
  }, [navigate]);

  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route index element={<HomePage />} />
        <Route path="schedule" element={<SchedulePage />} />
        <Route path="learn" element={<LearnPage />} />
        <Route path="achieve" element={<AchievePage />} />
        <Route path="me" element={<MePage />} />
        <Route path="me/mcp" element={<McpPage />} />
        <Route path="assistant" element={<AssistantPage />} />
        <Route path="assistant/settings" element={<AssistantSettingsPage />} />
        <Route path="login" element={<Navigate to="/" replace />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
